module.exports = __webpack_public_path__ + "img/check-icon.762526fb.svg";